"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rewardSettings = void 0;
const Alignment_1 = require("../../enums/Alignment");
const game_center_asset_1 = require("../../utils/game-center-asset");
exports.rewardSettings = {
    backgroundImage: (0, game_center_asset_1.getGameCenterAssetUrl)('reward-details.png'),
    backgroundColor: 'FFFFFF',
    headerFontStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '24px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    descriptionTextStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '18px',
        textAlign: Alignment_1.Alignment.CENTER,
    },
    buttonText: 'BUY HERE',
    buttonStyle: {
        color: 'FFFFFF',
        font: 'bebas',
        fontSize: '18px',
        textAlign: Alignment_1.Alignment.CENTER,
        top: '85%',
        borderRadius: '40px',
        backgroundColor: '58BFEB',
    },
    rewardPopUpText: 'Write your email to claim reward',
};
